// src/Section/Home/Terravia.jsx

import React from "react";
import Banner from "../../Section/Home/Banner/banner.jsx";
import Desktop from "../../Media/Header/Desktop/Desktop_Caelus.webp";
import Mobile from "../../Media/Header/Mobile/Mobile_Caelus.webp";
import About from "../../Section/Detail/about/about.jsx";
import Promo from "../../Section/Home/Promo/promo.jsx";
import Lokasi from "../../Section/Home/Lokasi/lokasi.jsx";
import Terraviadata from "./Caelus.json";
import promoData from "./promo.json";
import logo from "../../Media/RumahLogo/logocaelus.png";
import hardsell from "../../Media/Promo/Hardsell_Caelus.webp";
import Produk from "../Caelus/Caelus/Caelus1.jsx";

import Surrounding from "../../Section/Home/surrounding/Surrounding.jsx";

const Terravia = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        logo={logo}
        judul={Terraviadata.judul}
        Deskripsi={Terraviadata.deskripsi}
      />
      <Promo
        image={hardsell}
        title={promoData.title}
        points={promoData.points}
        whatsapp={promoData.whatsapp}
      />
      <Produk />

      <Surrounding />

      <Lokasi />
    </div>
  );
};

export default Terravia;
